// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

// Colors that match the Design System
const kishigoColors = {
    primary: "#253746",
    primaryAlt: "#4f758b",
    primaryDark: "#0e202e",
    secondary: "#FF5C39",
    secondaryAlt: "#c64125",
    tertiary: "#000000",
    success: "#008566",
    error: "#CC3535",
    warning: "#DC5133",
    info: "#4F758B",
    accentTitle: "#2C2A29",
    text: "#666666",
    link: "#FF5C39",
    black: "#000000",
    white: "#ffffff",
    grey: {
        pale: "#F8F8F8",
        light: "#EDEDED",
        main: "#DEDEDE",
        dark: "#63666A",
    },
};

const colors: Styleguide["colors"] = {
    primary: {
        main: kishigoColors.primary,
        contrast: kishigoColors.white,
        // Custom
        alt: kishigoColors.primaryAlt,
        dark: kishigoColors.primaryDark,
    },
    secondary: {
        main: kishigoColors.secondary,
        contrast: kishigoColors.white,
        // Custom
        alt: kishigoColors.secondaryAlt,
    },
    tertiary: {
        main: kishigoColors.tertiary,
        contrast: kishigoColors.white,
    },
    common: {
        background: kishigoColors.white,
        backgroundContrast: kishigoColors.text,
        accent: kishigoColors.grey.light,
        accentContrast: kishigoColors.text,
        border: kishigoColors.grey.main,
        disabled: "#e6e6e6",
        // Custom
        accentLighter: kishigoColors.grey.pale,
        borderLight: kishigoColors.grey.light,
        borderDark: kishigoColors.grey.dark,
        backgroundAlt: kishigoColors.black,
        borderColored: kishigoColors.primary,
    },
    text: {
        main: kishigoColors.text,
        disabled: kishigoColors.grey.light,
        accent: kishigoColors.accentTitle,
        link: kishigoColors.link,
        // Custom
        dark: kishigoColors.accentTitle,
        linkHover: kishigoColors.link,
        input: kishigoColors.text,
        inputSearch: kishigoColors.grey.dark,
    },
    success: {
        main: kishigoColors.success,
        contrast: kishigoColors.white,
    },
    danger: {
        main: kishigoColors.error,
        contrast: kishigoColors.white,
    },
    warning: {
        main: kishigoColors.warning,
        contrast: kishigoColors.white,
    },
    info: {
        main: kishigoColors.info,
        contrast: kishigoColors.white,
    },
    header: {
        main: "#253746", // None, look at header background color
        contrast: "#ffffff", // Text Color -> Main
        hover: "#FF5C39", // Primary -> Dark
        accent: "#ffffff", // Primary -> Main
        accentHover: "#FF5C39", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#253746", // None, look at main navigation background color
            contrast: "#ffffff", // Text Color -> Main
            hover: "#FF5C39", // Primary -> Main
            accent: "#ffffff", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#FF5C39", // Primary -> Main
            border: "", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#0e202e", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#FF5C39", // None, should match "primary.contrast"
        },
    },
};

export default colors;
